export const formatterNumber = (val) => {
  if (val === null || val === undefined || val === "") return "0";

  // Convert the number into a localized string format (de-DE for German locale)
  return parseFloat(val).toLocaleString("de-DE", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });
};

export const parserNumber = (val) => {
  if (!val || typeof val !== "string") return 0;

  // Reverse the localized formatting back to a number
  const parsed = val.replace(/\./g, "").replace(/,/g, ".");
  return isNaN(parsed) ? 0 : parseFloat(parsed);
};

export const convertNumberToCustomFormat = (number) => {
  // Convert the number to a string with a fixed decimal point
  const numberStr = number.toFixed(3);

  // Replace the dot with a comma
  return numberStr.replace(".", ",");
};

export const toHoursAndMinutes = (totalSeconds) => {
  let result = "";
  const totalMinutes = Math.floor(totalSeconds / 60);

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    result += hours + " jam ";
  }

  if (minutes >= 0 && hours > 0 && seconds > 0) {
    result += minutes + " menit ";
  } else if (minutes > 0) {
    result += minutes + " menit ";
  }

  if (seconds > 0) {
    result += seconds + " detik";
  }

  return result;
};

export const isNumeric = (value) => {
  return !isNaN(parseFloat(value)) && isFinite(value);
};
